import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function BedtimeOffIcon(props: IconProps) {
    return <Icon {...props} iconKey={"bedtime_off"}/>
}
